import { render, staticRenderFns } from "./game-view-toolbar.vue?vue&type=template&id=51d59081&"
import script from "./game-view-toolbar.vue?vue&type=script&lang=js&"
export * from "./game-view-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports